"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function Danger(_a) {
    var id = _a.id, className = _a.className, children = _a.children;
    return react_1.default.createElement("p", { id: id, className: storybook_1.Helpers.classNames('storybook-texts-danger', className) }, children);
}
exports.default = Danger;
Danger.propTypes = {
    /**
     * The id of the Heading
     */
    id: prop_types_1.default.string,
    /**
     * Add custom className
     */
    className: prop_types_1.default.string,
    /**
     * The text of the Heading
     */
    children: prop_types_1.default.node.isRequired,
};
